export const PAYPAL = 'paypal';
export const PAYPAL_LABEL = 'PayPal';

export const APPLE_PAY = 'applepay';
export const APPLE_PAY_LABEL = 'Apple Pay';

export const PAYMENT_METHODS = [
  {
    key: PAYPAL_LABEL,
    value: PAYPAL
  },
  {
    key: APPLE_PAY_LABEL,
    value: APPLE_PAY
  }
];


// WEBPACK FOOTER //
// ./src/common/PaymentMethodsConstants.js